'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _translate = require('../../language/translate');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Validates the values in the Get Quote portion of the form (the first page).
 * @param {Object} values - The values in the form to validate.
 * @returns {Object} Object of errors found in the form.
 */
exports.default = function (values, props) {
  return {
    applicant: values.applicant.map(function (applicant, i) {
      return {
        dob: !applicant.dob,
        first_name: !applicant.first_name,
        last_name: !applicant.last_name,
        email: i === 0 && !applicant.email,
        additional_data: {
          school: values.application.additional_data.school !== 'other' && !applicant.additional_data.school,
          school_other: (values.application.additional_data.school === 'other' || applicant.additional_data.school === 'other') && !applicant.additional_data.school_other,
          relationship_to_primary_applicant: i > 0 && !applicant.additional_data.relationship_to_primary_applicant
        }
      };
    }),
    application: {
      effective_date: !values.application.effective_date,
      additional_data: {
        eligibility: !values.application.additional_data.eligibility,
        coverage_type: !values.application.additional_data.coverage_type,
        school: !values.application.additional_data.school,
        school_other: values.application.additional_data.school === 'other' && !values.application.additional_data.school_other
      }
    },
    errors: props.application.quote.information && Array.isArray(props.application.quote.information)
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/validators/student-accident/Quote.js
// module id = 1783
// module chunks = 0